import React from "react";
import { ArrowUpRight, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { mediaUrl } from "../../lib/api";
import { money, trackRacex } from "./racex";

export const OfferLink = ({ event, placement, children, className = "rx-button" }) => (
  <a href="#racex-enquire" className={className} data-testid={`racex-${placement}-enquire-button`} onClick={() => trackRacex("offer_click", placement)}>
    {children || (event?.accepting_enquiries ? `Get the ${money(event.price_cents)} offer` : "Contact NQ Springs")}
    <ArrowUpRight size={18} aria-hidden="true" />
  </a>
);

export const RacexPhone = ({ contact, placement, children, className = "rx-call" }) => contact?.phone ? (
  <a href={`tel:${contact.phone.replace(/[^+\d]/g, "")}`} className={className} data-testid={`racex-${placement}-call-button`} onClick={() => trackRacex("call_intent", placement)}>
    <Phone size={17} aria-hidden="true" />{children || contact.phone}
  </a>
) : null;

export const RacexHeader = ({ site, event }) => (
  <header className="rx-header">
    <div className="rx-container rx-header-inner">
      <Link to="/" className="rx-logo" aria-label="NQ Springs home" data-testid="racex-home-link">
        {site?.branding?.logo ? <img src={mediaUrl(site.branding.logo)} alt="NQ Springs 4x4 accessories" /> : <span>NQ SPRINGS</span>}
      </Link>
      <nav aria-label="RACEX event" className="rx-nav">
        <a href="#racex-experience" data-testid="racex-experience-link">The experience</a>
        <a href="#racex-film" data-testid="racex-film-link">The film</a>
        <a href="#racex-gallery" data-testid="racex-gallery-link">Race day</a>
        <a href="#racex-faq" data-testid="racex-faq-link">FAQs</a>
      </nav>
      <div className="rx-header-actions">
        <RacexPhone contact={site?.contact} placement="header" />
        {event && <OfferLink event={event} placement="header" />}
      </div>
    </div>
  </header>
);

export const RacexFooter = ({ site, event }) => (
  <>
    <footer className="rx-footer">
      <div className="rx-container rx-footer-main">
        <div><p className="rx-kicker">LOCAL PEOPLE. A PROPER DAY OUT.</p><strong data-testid="racex-footer-brand">NQ Springs, Townsville.</strong><p data-testid="racex-footer-address">{site?.contact?.address}</p></div>
        <div className="rx-footer-contact"><RacexPhone contact={site?.contact} placement="footer" />
          {site?.contact?.email && <a href={`mailto:${site.contact.email}?subject=RACEX%20Townsville%20enquiry`} data-testid="racex-footer-email-link">{site.contact.email}</a>}
        </div>
      </div>
      <div className="rx-container rx-footer-bottom"><span>© {new Date().getFullYear()} NQ Springs</span><Link to="/privacy-policy" data-testid="racex-footer-privacy-link">Privacy policy</Link><Link to="/" data-testid="racex-footer-website-link">NQ Springs website <ArrowUpRight size={14} /></Link></div>
    </footer>
    {event && <div className="rx-mobile-bar" data-testid="racex-mobile-sticky-bar"><RacexPhone contact={site?.contact} placement="mobile">Call NQ Springs</RacexPhone><OfferLink event={event} placement="mobile" /></div>}
  </>
);